export default "__VITE_ASSET__BkHDFbel__"